import { ImportPreviewTableRow } from 'entities/ui/model/absence';

// Определяет есть ли ошибка в строке
export const isError = (obj: ImportPreviewTableRow) => {
  const { errors, startedAt, endedAt } = obj;
  return errors?.date || errors?.duplicate || errors?.employee || errors?.interval || !startedAt || !endedAt;
};

export const sortByPersonnelNumber = (a: ImportPreviewTableRow, b: ImportPreviewTableRow): number => {
  if (a.errors?.employee && !b.errors?.employee) return 1;
  if (!a.errors?.employee && b.errors?.employee) return -1;
  return Number(b.personnelNumber) - Number(a.personnelNumber);
};
